// search input component with handlers for search and clear

import { Box, Input, InputProps, SxProps, Theme } from '@mui/material';
import { Icon, Icons } from '@/common/components/Icon/Icon';
import {
  iconStyles,
  inputStyles,
  searchBoxStyles,
} from '@/widgets/ListContainer/components/SearchBox/SearchBox.styles';

interface ISearchBoxProps extends InputProps {
  sx?: SxProps<Theme>;
}

export default function SearchBox({ sx, ...props }: ISearchBoxProps) {
  return (
    <Box sx={{ ...searchBoxStyles, ...sx } as SxProps<Theme>}>
      <Input {...props} sx={inputStyles} disableUnderline />
      <Icon sx={iconStyles} icon={Icons.Search} />
    </Box>
  );
}
